export default __webpack_public_path__ + "static/media/zunayed.25bb5827.jpg";